import { IDevolutionDeposit } from "@/types/devolution-deposit";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";


const API_URL = `${import.meta.env.VITE_API_URL}/devolution-deposit`;
const makeRequestDebounced = createDebounce(makeRequest, 200);


export async function createReturnOfDeposit(
  data: Partial<IDevolutionDeposit>
): Promise<ApiResponseType<IDevolutionDeposit>> {
  const url = `${API_URL}/`;
  const options: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const result = (await makeRequestDebounced(
    url,
    options
  )) as ApiResponseType<IDevolutionDeposit>;

  return result;
}


export async function getAllReturnOfDeposits(): Promise<IDevolutionDeposit[]> {
  const url = `${API_URL}/`;
  const options: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const result = (await makeRequestDebounced(
    url,
    options
  )) as ApiResponseType<IDevolutionDeposit[]>;

  return (result.data ?? result) as IDevolutionDeposit[];
}


export async function updateReturnOfDeposit(renterId: string, pathFile: string) {
  const url = `${API_URL}/${renterId}`;

  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ file: pathFile }),
  };

  const result = (await makeRequestDebounced(url, options)) as Promise<ApiResponseType<IDevolutionDeposit>>;

  return result;
}

